import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-email-aktualisieren-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerEmailAktualisierenAdminEffects {

    BenutzerEmailAktualisierenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_EMAIL_AKTUALISIEREN_ADMIN),
        mergeMap((x: ac.PostBenutzerEmailAktualisierenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerEmailAktualisierenAdmin(x.benutzerEmailAktualisierenRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerEmailAktualisierenAdminErfolgreichAction(result, x.benutzerEmailAktualisierenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerEmailAktualisierenAdminFehlerAction(error, x.benutzerEmailAktualisierenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminCommandService);
        }
        return this.service;
    }
}
